import React, { useEffect, useState } from "react";
import {Select, Button, Card, Form, notification, Skeleton, Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useStoreUpdaterWithAPI } from "../../../../Hooks/UseStoreUpdaterWithApi";
import {  MeterConfigGrid } from "../../../../Common/UIConstants";
import { useSelector } from "react-redux";

import {  CONFIGURATION_METER } from "../../../../Common/Constants";
import MeterPopup from "../../../CommonScreens/CreateMeter";
const { Option } = Select;

const MeterConfiguration = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { loading, makeRequest } = useStoreUpdaterWithAPI();
    
    const [isAdd, setIsAdd] = useState(false);
   
    const mode = useSelector((state) => state.darkMode);
  
    const { isdarkMode } = mode;
  
    const [form] = Form.useForm();
  
    useEffect(() => {
    
    }, []);
  
    useEffect(() => {
      if (location.pathname === `${CONFIGURATION_METER}/meter-add-popup`) {
        setIsAdd(true);
       
      }else {
        setIsAdd(false);
      }
    }, [location.pathname]);
  
   
  
    const handleNotification = (msg) => {
      notification.open({
        message: `${msg}`,
      });
    };
  
    const handleAddPopup = () => {
      navigate(`${CONFIGURATION_METER}/meter-add-popup`);
    };
  
  
  
    const handleDeletePopup = (record) => {
      setSelectedDeleteData(record.groupID);
    };
  
    const handleDeleteSubmit = (groupID) => {
      try {
        makeRequest({
          type: APIConstants.DELETE,
          url: `${APIConstants.DELETE_FLOW_GROUP_DETAILS}?GroupID=${groupID}&IsDelete=true`,
        });
  
        const updatedFlowGroupList = flowGroupList.filter(
          (item) => item.groupID !== groupID
        );
        setFlowGroupList(updatedFlowGroupList);
  
        handleNotification("Successfully Deleted");
        form.resetFields();
      } catch (err) {
        console.log(err);
      }
    };
  
    return (
      <div>
        <Card className={`w-full h-auto dark ${isdarkMode ? 'darkmode border-0' : 'whitemode'} `}>
          <div className="flex justify-end">
            <Button onClick={handleAddPopup} className="blue-btn mb-2">
              Add Meter
            </Button>
          </div>
  
          <MeterPopup
            isAdd={isAdd}
            setIsAdd={setIsAdd}
            title={"Meter Details"}
           
           
          />
  
          <div className="overflow-auto">
            <h2 className={`${isdarkMode ? 'darkfont' : 'whitemode'}`}>MeterGrid View</h2>
            <Select
        // value={selectedLanguage}
        // onChange={handleLanguageChange}
        style={{ width: 120, marginBottom: 16 }}
      >
        <Option value="1">1</Option>
        <Option value="2">2</Option>
        <Option value="3">3</Option>
        
      </Select>
           
            {/* <Spin indicator={<Spin size="large" />} spinning={loading}>
              <MeterConfigGrid
              
                handleDeletePopup={handleDeletePopup}
                handleDeleteSubmit={handleDeleteSubmit}
               
              />
            </Spin> */}
          </div>
        </Card>
      </div>
    );
};

export default MeterConfiguration;
